export default __webpack_public_path__ + "static/media/04_DAIF_Infra_04_04_loop.8d983ec5.mp4";